import script from "./CustomNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&setup=true&lang=js"

import "./CustomNavbar.vue?vue&type=style&index=0&id=47325aaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47325aaa"]])

export default __exports__